/**
* @ngDoc service
* @name LabelColorService
* @description Calcule the best color contrast for foreground elements using background color.
*/
var app = angular.module("nms");

app.service("LabelColorService", [
    function() {
        var blackClass = "text-black";
        var whiteClass = "text-white";

        /**
         * Calcula a distância do background com cores claras e escuras.
         */
        this.calculateYiq = function(backgroundColor) {
            var isHexColor = /^#([a-fA-F\d]{3}){1,2}$/.test(backgroundColor);
            backgroundColor = isHexColor ? this.hexToRgb(backgroundColor) : backgroundColor;

            var isTransparentBackground = _.contains(backgroundColor, "rgba");

            if (isTransparentBackground) {
                return 128;
            }

            var rgbColors = backgroundColor.match(/\d+/g);
            var red = rgbColors[0];
            var green = rgbColors[1];
            var blue = rgbColors[2];

            return ((red * 299) + (green * 587) + (blue * 114)) / 1000;
        }

        /**
         * Retorna a melhor cor a ser usada no texto de acordo com o YIQ calculado de acordo com o background.
         * Os valores podem ser:
         * - #000: preto (YIQ >= 128)
         * - #fff: branco (YIQ < 128)
         */
        this.getBestColorContrastForForeground = function(backgroundColor) {
            return this.calculateYiq(backgroundColor) >= 128 ? "#000" : "#fff";
        };

        /**
         * Retorna a melhor classe a ser usada no texto de acordo com o background.
         * Os valores podem ser:
         * - text-black (YIQ >= 128)
         * - text-white (YIQ < 128)
         */
        this.getBestColorContrastClassForForeground = function(backgroundColor) {
            return this.calculateYiq(backgroundColor) >= 128 ? blackClass : whiteClass;
        };

        this.hexToRgb = function(rawColorHex) {

            let colorHexa = rawColorHex.replace(/^#/, "");

            if (colorHexa.length === 3) {
              colorHexa = colorHexa.split("").map(hex => hex + hex).join("");
            }

            const bigint = parseInt(colorHexa, 16);
            const red = (bigint >> 16) & 255;
            const green = (bigint >> 8) & 255;
            const blue = bigint & 255;

            return `rgb(${red},${green},${blue})`;
        };
    }
]);
